<template>
  <el-row :gutter="20">
    <div
      class="name"
      style="
        border: solid #ffffff;
        width: 1700px;
        height: 40px;
        line-height: 20px;
        text-align: center;
      "
    >
      <span style="font-size: 20px">{{
        "项目名称：" + this.projectList.name
      }}</span>
      <el-divider direction="vertical" content-position="right"></el-divider>
      <span style="font-size: 20px">{{
        "项目代码：" + this.projectList.code
      }}</span>
    </div>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div class="echart" id="mychart" :style="myChartStyle"></div>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div class="echart" id="projectConsume" :style="myChartStyle"></div>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div class="echart" id="projectHour" :style="myChartStyle"></div>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div class="echart" id="projectConsumeHour" :style="myChartStyle"></div>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div class="echart" id="projectJobConsume" :style="myChartStyle"></div>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div class="echart" id="projectJobHour" :style="myChartStyle"></div>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import * as echarts from "echarts";
export default {
  props: ["projectList"],
  data() {
    return {
      value1: "",
      value2: "",
      myChart: {},
      pieData: [
        {
          value: 5,
          name: "1111111111",
        },
        {
          value: 22.5,
          name: "55555555555",
        },
        {
          value: 30,
          name: "33333333333",
        },
        {
          value: 2.5,
          name: "88888888888",
        },
      ],
      consumeData: [],
      hourData: [],
      consumeHourData: [],
      jobConsumeData: [],
      jobHourData: [],
      pieName: "adasd",
      myChartStyle: { float: "left", width: "100%", height: "400px" }, //图表样式，
    };
  },
  mounted() {
    this.initDate(this.projectList.id);
  },
  methods: {
    initDate(e) {
      let p1 = new Promise((resolve, reject) => {
        httpKit.post($api_pms.home.projectConsume, { id: e }).then((res) => {
          // this.refreshing = false;
          console.log(res);
          if (res.data.code === "200") {
            console.log("ok");
            this.pieName = res.data.data.projectName;
            this.pieData = res.data.data.actualValue;
            resolve();
          } else if (res.data.code === "500") {
            this.pieName = {};
            this.pieData = [];
            console.log("err");
          }
        });
      });
      let p2 = new Promise((resolve, reject) => {
        httpKit.post($api_pms.home.projectProper, { id: e }).then((res) => {
          console.log(res);
          if (res.data.code === "200") {
            console.log("ok");
            this.consumeData = res.data.data.actualValue;
            resolve();
          } else if (res.data.code === "500") {
            this.item = {};
            console.log("err");
          }
        });
      });
      let p3 = new Promise((resolve, reject) => {
        httpKit.post($api_pms.home.projectHour, { id: e }).then((res) => {
          console.log(res);
          if (res.data.code === "200") {
            console.log("ok");
            this.hourData = res.data.data.actualValue;
            resolve();
          } else if (res.data.code === "500") {
            this.item = {};
            console.log("err");
          }
        });
      });
      let p4 = new Promise((resolve, reject) => {
        httpKit
          .post($api_pms.home.projectConsumeHour, { id: e })
          .then((res) => {
            console.log(res);
            if (res.data.code === "200") {
              console.log("ok");
              this.consumeHourData = res.data.data.actualValue;
              resolve();
            } else if (res.data.code === "500") {
              this.item = {};
              console.log("err");
            }
          });
      });
      let p5 = new Promise((resolve, reject) => {
        httpKit.post($api_pms.home.projectJobConsume, { id: e }).then((res) => {
          console.log(res);
          if (res.data.code === "200") {
            console.log("ok");
            this.jobConsumeData = res.data.data.actualValue;
            resolve();
          } else if (res.data.code === "500") {
            this.item = {};
            console.log("err");
          }
        });
      });
      let p6 = new Promise((resolve, reject) => {
        httpKit.post($api_pms.home.projectJobHour, { id: e }).then((res) => {
          console.log(res);
          if (res.data.code === "200") {
            console.log("ok");
            this.jobHourData = res.data.data.actualValue;
            resolve();
          } else if (res.data.code === "500") {
            this.item = {};
            console.log("err");
          }
        });
      });
      Promise.all([p1, p2, p3, p4, p5, p6])
        .then((result) => {
          console.log("成功了", result);
          this.initEcharts();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleQuery() {
      console.log(this.value2);
      console.log(this.value1);
      this.initDate();
    },
    initEcharts() {
      // 饼图
      const option = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.pieData,
          },
        ],
        title: {
          text: "项目岗位消耗成本",
          left: "center",
        },
      };
      const optionConsume = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.consumeData,
          },
        ],
        title: {
          text: "项目人员消耗成本",
          left: "center",
        },
      };
      const optionHour = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.hourData,
          },
        ],
        title: {
          text: "项目人员消耗工时",
          left: "center",
        },
      };
      const optionConsumeHour = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.consumeHourData,
          },
        ],
        title: {
          text: "项目岗位消耗工时",
          left: "center",
        },
      };
      const optionJobConsume = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.jobConsumeData,
          },
        ],
        title: {
          text: "按工作类别统计消耗成本",
          left: "center",
        },
      };
      const optionJobHour = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.jobHourData,
          },
        ],
        title: {
          text: "按工作类别统计消耗工时",
          left: "center",
        },
      };
      console.log(this.seriesData);
      const optionFree = {
        xAxis: {},
        yAxis: {},
        series: [
          {
            data: this.seriesData,
            type: "line",
            smooth: true,
          },
        ],
      };
      this.myChart = echarts.init(document.getElementById("mychart"));
      this.myChart.setOption(option);
      this.projectConsume = echarts.init(
        document.getElementById("projectConsume")
      );
      this.projectConsume.setOption(optionConsume);
      this.projectHour = echarts.init(document.getElementById("projectHour"));
      this.projectHour.setOption(optionHour);
      this.projectConsumeHour = echarts.init(
        document.getElementById("projectConsumeHour")
      );
      this.projectConsumeHour.setOption(optionConsumeHour);
      this.projectJobConsume = echarts.init(
        document.getElementById("projectJobConsume")
      );
      this.projectJobConsume.setOption(optionJobConsume);
      this.projectJobHour = echarts.init(
        document.getElementById("projectJobHour")
      );
      this.projectJobHour.setOption(optionJobHour);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
        this.projectConsume.resize();
        this.projectHour.resize();
        this.projectConsumeHour.resize();
        this.projectJobConsume.resize();
        this.projectJobHour.resize();
      });
    },
  },
};
</script>
